import { useUserPreference } from "./useUserPreference.js";

export interface CardExpandedStore {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  loading: boolean;
}

export const useCardExpandedStore = (
  key: string,
  defaultExpanded: boolean
): CardExpandedStore => {
  const pref = useUserPreference<boolean>(
    `CardContainer-${key}`,
    defaultExpanded
  );
  return {
    isExpanded: pref.value,
    setIsExpanded: pref.saveValue,
    loading: pref.loading,
  };
};
